import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { Flex, Typography } from 'antd';
import { BannerIcon, BannerWrapper } from '../sent/IntegrationBanner';
const { Text, Title } = Typography;

export interface ISubmissionDelegationBannerProps {}

/**
 * Banner di avviso in caso di richiesta delegata
 */
export function SubmissionDelegationBanner(
  props: ISubmissionDelegationBannerProps,
) {
  const { t } = useTranslation();

  return (
    <BannerWrapper>
      <Flex align="center" justify="center" gap={12}>
        <BannerIcon>
          <InfoCircleOutlined aria-label="Informazione" />
        </BannerIcon>
        <Text strong>
          {t(
            'submission.delegation-banner.stai-commpilando-in-delega-la-richiesta',
            'Stai visualizzando questa richiesta come delegato.',
          )}
        </Text>
      </Flex>
    </BannerWrapper>
  );
}
